(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reliup-pdp-conversion-panel"] && !Shopify.designMode) return;
  try {
    (() => {
    const getVersionKey = (scope) => {
      const radio = scope.querySelector('input[type="radio"][name="Version"]:checked');
      const select = scope.querySelector('select[name="options[Version]"]');
      const value = radio?.value || select?.value || '';

      return value.toLowerCase().includes('camera') ? 'ai-camera' : 'standard';
    };

    const updateVariantIncludes = (container) => {
      const scope = container.closest('.product__info') || document;
      const versionKey = getVersionKey(scope);

      container.querySelectorAll('[data-reliup-includes-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.reliupIncludesPanel !== versionKey;
      });
    };

    const updateAllVariantIncludes = () => {
      document.querySelectorAll('[data-reliup-variant-includes]').forEach(updateVariantIncludes);
    };

    document.addEventListener('change', (event) => {
      if (event.target.matches('input[type="radio"][name="Version"], select[name="options[Version]"]')) {
        updateAllVariantIncludes();
      }
    });

    document.addEventListener('DOMContentLoaded', updateAllVariantIncludes);
    document.addEventListener('shopify:section:load', updateAllVariantIncludes);
  })();
  } catch(e) { console.error(e); }
})();

})();
